module.exports = __webpack_public_path__ + "media/images/smart_phone/menus/btn_teisei-957ee6d11dfe61839696a84f59364ece.png";